import { ProgressBar } from "solid-bootstrap";
import { Accessor, Component } from "solid-js";

type Props = {
    value: Accessor<number>;
    min: number;
    max: number;
}
export const MultiProgress : Component<Props> = (props) => {
    const cent = (value: number) => (100/props.min) * value;
    const now = () => cent(props.value());
    const minLeft = () => {
        const value = cent(props.min - props.value());
        return value > 0 ? value : 0;
    }
    const remain = () => {
        const value = 100 - now() - cent(props.min);
        return value < 0 ? cent(props.max - props.min) : value;
    }
    return (
        <ProgressBar>
            <ProgressBar variant="success" now={now()} />
            <ProgressBar striped variant="danger" now={minLeft()} />
            <ProgressBar striped variant="warning" now={remain()} />
        </ProgressBar>
    )
}